import React from 'react';
import WizardExploraModalForm from './wizard_explora_modal';
import { Select } from 'antd';
import { Button } from '@progress/kendo-react-buttons'
import services from '../../services';

const { Option } = Select;

class WizardTitularModalForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         popUpForm: '',
         data: [],
         entityDataList: [],
         parcelHolder: {},
         holderDetail: {},
         searchValid: 0,
         optionsEntityList: '',
         entity_list_object: {},
         defaultSelection: "",
         error:null,
      }
   }

   /* Esta é a primeira etapa após o construxctor para carregar este componente  */

   componentDidMount() {
      //console.log("onmount",this.props.parcelData);
      this.state.defaultSelection = "";
      let parcelData = this.props.parcelData;
      if (parcelData) {
         if (!Array.isArray(parcelData)) {
            parcelData = [parcelData]
         }
      }
      this.setState({
         data: parcelData,
         optionsEntityList:''
      },()=>this.getEntityListObject())
   }

   componentDidUpdate(prevProps) {
      if (prevProps.tab !== this.props.tab) {
         this.state.defaultSelection = "";
         //console.log("onUpdate",this.props.parcelData);
         let parcelData = this.props.parcelData;
         if (parcelData) {
            if (!Array.isArray(parcelData)) {
               parcelData = [parcelData]
            }
         }
         this.setState({
            data: parcelData,
            defaultSelection: null,
            optionsEntityList:''
         },()=>this.getEntityListObject())
      }
   }

   getEntityListObject = async () => {
      let entityListObject = {}
      if(this.props.tab !== 'parcel' && this.state.data && this.state.data.length > 0){
         for (let i = 0; i < this.state.data.length; i++) {
            const element = this.state.data[i];
            
            let res = await services.EntityList.getEntityList('parcel', null,element.entnum);
            if(res){
               entityListObject = {...entityListObject,...res.entity_row}
            }
         }

         this.setState({entity_list_object : entityListObject})
      }
   }

   addDatatoMainData = (setdata) => {
      let data = [];
      let alreadySet = false
      //console.log("After for submit",setdata,this.state.data);
      if (this.state.data) {
         data = [...this.state.data]
      }
      data.map((_r, i) => {
         if (_r.entnum && ((_r.entnum).trim() === setdata.entnum)) {
            alreadySet = true;
            if (Object.keys(setdata).length > 1)
               data[i] = setdata;
         }
      })
      if (!alreadySet) {
         data.push(setdata)
      }
      //console.log("After form submit",data);
      this.setState({
         data
      }, () => this.props.getPopUpFormState(this.state.data, this.props.tab))
   }

   popUpDetailEntry = (row, index) => {
      try {
         //console.log("onformopen",row);
         let popUpForm = (
            <WizardExploraModalForm tab={this.props.tab} date={new Date()} all_list={this.props.all_list} closePopup={() => this.props.closePopup()} entity={this.state.entity_list_object[(row.entnum).trim()]} index={index} row={row} getPopUpFormState={(data, index, tab) => this.getPopUpFormState(data, index, tab)} />
         )
         this.setState({
            popUpForm
         })
      } catch (error) {
         this.setState({error})
      }
   }

   getPopUpFormState = (formData, tab) => {
      this.addDatatoMainData(formData);

   }

   handleSelect = async (value) => {
     try {
       await this.entitypermissoncheck(value);
      } catch (error) {
         this.setState({error})
      }
   }

   entitypermissoncheck = async (nif) => {
      let id = this.state.entity_list_object[nif].codEntidade;
      let data = {
         id: Number(id),
         modulename: "parcel"
      }
      let res = await services.apiCall.requestApi('/Entity/CheckPermission', data, 'post');
      if (res) {
         let newEntityId = {
            entnum: nif
         }
         this.addDatatoMainData(newEntityId);
      }
   }


   entityListOption = () => {
      //console.log("ENTITYLIST",this.state.entityDataList)
      let optionsEntityList = (
         this.state.entityDataList.map((_r, i) => (
            <Option value={_r.nif}>{_r.nome}<br />{_r.nifap}</Option>
         ))
      )

      this.setState({
         optionsEntityList
      })
   }


   handleParcelHolder = (row) => {
      try {
         this.props.getPopUpFormState(row, this.props.tab);
         this.props.closePopup()
      } catch (error) {
         this.setState({error})
      }
   }

   onSearch = async (e) => {
      try {
         if (e.length >= 3) {

            let res = await services.EntityList.getEntityList('parcel', e);
            if (res) {
               let entityListObject = {...this.state.entity_list_object, ...res.entity_row }
               this.setState({
                  entityDataList: res.entityList,
                  entity_list_object: entityListObject,
                  searchValid: e.length,
   
               }, () => this.entityListOption())
            }
         } else {
            this.setState({
               searchValid: 0
            })
         }
         this.setState({ defaultSelection: e })
      } catch (error) {
         this.setState({error})
      }
   }


   render() {
      if(this.state.error){
         throw this.state.error
      }
      return (
         <div className="modal-content">
            <div className="modal-header">
               <h4 className="modal-title pl-0">Associar {
                  this.props.tab === 'parcel' ? "Titular"
                     : this.props.tab === 'parcelProperty' ? 'Proprietário' : 'Exploradores'
               }
               </h4>
               {/* <button type="button" className="btn btn-success btn-sm text-uppercase mr-3">Guardar</button>  */
               }
               <Button primary={true} onClick={() => this.props.closePopup()} className="remoove btn-ivdp-primary cursor-pointer mr-2">Fechar</Button>
            </div>
            <div className="modal-body">
               <div className="form-group position-relative">
                  <div className="input-box active-grey">
                     {/* <label className="input-label">Pesquisar por Nº ou Nome</label>  */
                     }
                     {/* <input type="text" name="searchKey" value={this.state.searchKey} onChange={this.handleChange} className="input-1" placeholder="Pesquisar por Nº ou Nome"/>  */
                     }

                     <Select
                        onChange={this.handleSelect}
                        showSearch
                        onSearch={this.onSearch}
                        style={{ width: "100%" }}
                        value={this.state.defaultSelection || ""}
                        //defaultValue={""}
                        placeholder="Pesquisar por Nº ou Nome"
                        optionFilterProp='children'
                        notFoundContent="Entidade não encontrada, refina os critérios de pesquisa"
                     >
                        {/* <Option value="" disabled>Pesquise por Nome ou Nº</Option>  */
                        }
                        {
                           this.state.searchValid >= 3 &&
                           this.state.optionsEntityList
                        }
                     </Select>

                  </div>
                  <span className="cursor-pointer search-icon">
                     <i className="fas fa-search"></i>
                  </span>
                  {
                     this.state.data && this.state.entity_list_object ?
                     this.state.data.map((_r, i) => (
                        _r.entnum && this.state.entity_list_object[(_r.entnum).trim()] &&
                        <div className="listing" key={i}>
                           <span className="d-flex justify-content-between cursor-pointer align-items-center">
                              <div>
                                 <p className="top-head m-0">{this.state.entity_list_object[(_r.entnum).trim()] && this.state.entity_list_object[(_r.entnum).trim()].nome}</p>
                                 <p className="small font-14 m-0 d-md-flex">{this.state.entity_list_object[(_r.entnum).trim()] && this.state.entity_list_object[(_r.entnum).trim()].nifap}
                              {
                                 this.props.Parcel['parcel']['titdireito'] === _r.entnum &&
                                    <span class="ml-2 titular-tag">Titular</span>
                              }
                              </p>
                              </div>
                              <div>
                                 {
                                    this.props.tab !== 'parcel' ?
                                       <span data-toggle="modal" data-target='#left-explor-popup' onClick={() => this.popUpDetailEntry(_r, i - 1)} className="cursor-pointer"><i className="fas fa-plus-circle"></i></span>
                                       :
                                       <span data-toggle="modal" data-target='#left-explor-popup' onClick={() => this.handleParcelHolder(_r)} className="cursor-pointer"><i className="fas fa-plus-circle"></i></span>
                                 }
                              </div>
                           </span>
                        </div>
                     ))
                   :  this.props.tab === 'parcelProperty' ? 
                     <div className="searct-found">
                        <img className="img-fluid" src="imgs/search-large-icon.png" />
                        <p className="font-14">Sem proprietários</p>
                        <h5>Associe pelo menos um proprietário ao registo</h5>
                     </div>
                     :
                     this.props.tab === 'parcelExplorer' &&
                     <div className="searct-found">
                        <img className="img-fluid" src="imgs/search-large-icon.png" />
                        <p className="font-14">Sem exploradores</p>
                        <h5>Associe pelo menos um explorador ao registo</h5>
                     </div>
                     
                  }
                  {
                       this.props.tab === 'parcel' && this.state.data && this.state.data.length < 2 ?
                       <div className="searct-found">
                          <img className="img-fluid" src="imgs/search-large-icon.png" />
                          <p className="font-14">Sem  titular</p>
                          <h5>Associe a entidade titular do direito ao registo</h5>
                       </div>
                        :
                        ''
                  }
               </div>
               <div className="modal left-popup" id="left-explor-popup">
                  <div className="modal-dialog modal-sm">
                     {
                        this.state.popUpForm
                     }
                  </div>
               </div>
            </div>
         </div>

      )
   }
}

export default WizardTitularModalForm;